document.addEventListener('DOMContentLoaded', function () {
  var section = document.getElementById('fc-faq-section');
  if (!section) return;

  if ('IntersectionObserver' in window) {
    var bgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fc-bg-visible');
        } else {
          entry.target.classList.remove('fc-bg-visible');
        }
      });
    }, { threshold: 0, rootMargin: '-10% 0px -10% 0px' });

    bgObserver.observe(section);
  } else {
    section.classList.add('fc-bg-visible');
  }

  var animEls = Array.prototype.slice.call(section.querySelectorAll('.fc-faq-anim'));

  animEls.forEach(function (el, index) {
    el.style.transitionDelay = (index * 70) + 'ms';
  });

  if ('IntersectionObserver' in window) {
    var elObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.15 });

    animEls.forEach(function (el) {
      elObserver.observe(el);
    });
  } else {
    animEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
});